<div class="bc-email-viewer">
  <div class="email-panel-heading">
    <div class="email-header">
      <div class="email-header-title">
        <div class="email-header-subject" [attr.data-automation-id]="'bc-email-header-subject'">
          {{ email.subject }}
        </div>
        <div class="email-header-details">
          <div class="email-header-details-visible-row">
            <div class="email-header-started" [attr.data-automation-id]="'bc-email-header-started'">
              {{ moment(email.sentDate).format('LLL') }}
            </div>
            <app-copy-text-to-clipboard
              [linkText]="'bcEmailViewer.copyEmailThreadId' | translate"
              [textToCopy]="emailId">
            </app-copy-text-to-clipboard>
            <div class="email-header-details-actions">
              <a class="email-header-details-toggle"
                 target="_blank"
                 tabindex="0"
                 (keyup.enter)="toggleDetails()"
                 (click)="toggleDetails()"
                 [attr.data-automation-id]="'bc-email-header-details-toggle'">
                <span *ngIf="detailsExpanded">{{ 'bcEmailViewer.details.collapse' | translate }}</span>
                <span *ngIf="!detailsExpanded">{{ 'bcEmailViewer.details.expand' | translate }}</span>
              </a>
              <div class="email-header-details-line-separator"></div>
              <div>
                <a class="email-header-details-open-window"
                   target="_blank"
                   (click)="trackOpenEmailInNewWindow()"
                   [href]="redirectUrl"
                   copy-text-link>
                  <svg-icon icon="pop-out"></svg-icon>
                </a>
              </div>
            </div>
          </div>
          <div class="email-header-recipient" [hidden]="!detailsExpanded">
            <div>
              <div class="recipient-label" [attr.data-automation-id]="'bc-email-header-from-label'">{{ 'bcEmailViewer.recipient.from' | translate }}</div>
              <div class="recipient-value" [attr.data-automation-id]="'bc-email-header-from-value'">{{ email.fromFullEmailAddress }}</div>
            </div>
            <div *ngIf="email.toFullEmailAddresses">
              <div class="recipient-label">{{ 'bcEmailViewer.recipient.to' | translate }}</div>
              <div class="recipient-value">{{ email.toFullEmailAddresses }}</div>
            </div>
            <div *ngIf="email.ccFullEmailAddresses">
              <div class="recipient-label">{{ 'bcEmailViewer.recipient.cc' | translate }}</div>
              <div class="recipient-value" [attr.data-automation-id]="'bc-email-header-cc-value'">{{ email.ccFullEmailAddresses }}</div>
            </div>
            <div *ngIf="email.bccFullEmailAddresses">
              <div class="recipient-label">{{ 'bcEmailViewer.recipient.bcc' | translate }}</div>
              <div class="recipient-value" [attr.data-automation-id]="'bc-email-header-bcc-value'">{{ email.bccFullEmailAddresses }}</div>
            </div>
          </div>
        </div>

        <app-email-attachments [attachments]="email.attachments"></app-email-attachments>
      </div>
    </div>
  </div>
  <div class="bc-email-body" *ngIf="email">
    <app-secure-frame [content]="emailBody" [emailId]="emailId" (onLoad)="bodyLoaded.emit()"></app-secure-frame>
  </div>
</div>
